<template>
  <div class="form-group mt-5" :class="{ hasValue: showInput || value }">
    <input
      autocomplete="off"
      ref="item"
      :type="config.InputType"
      :name="'text' + id"
      :key="'text' + id"
      :data-vv-as="config.ErrorMessage"
      v-validate="config.Validation"
      :id="'input' + id"
      class="form-control"
      :value="value"
      :required="config.Validation.required"
      length="2"
      @input="update()"
      @change="doChange()"
      @blur="update()"
    />
    <label class="form-control-placeholder" :for="'input' + id">
      <span>{{ config.Placeholder }}</span>
      <span
        class="required-star"
        v-if="config.Validation.required && config.Placeholder"
        >*</span
      >
    </label>
    <InfoText v-if="config.Info" :content="config.Info" :id="id" />
    <div class="invalid-feedback" ref="error">
      {{ errors.first('text' + id) }}
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import InfoText from '@/components/base/InfoText';
  export default {
    components: { InfoText },
    inject: {
      $validator: '$validator',
    },
    props: ['value', 'id', 'config'],
    data() {
      return {
        showInput: false,
        countryList: [],
      };
    },
    methods: {
      update() {
        // check if valid
        if (this.value || this.$refs.item.value) {
          this.showInput = true;
        } else {
          this.showInput = false;
        }
        this.innerValue = this.$refs.item.value.toUpperCase();
        this.$emit('input', this.$refs.item.value.toUpperCase());
        let country = this.countryList.filter(
          (el) => el.code.toUpperCase() === this.innerValue.toUpperCase()
        );

        if (country.length) {
          this.$emit('getNewData', country[0].name);
        } else {
          this.$emit('getNewData');
        }
      },
      doChange() {
        this.$refs.error.style.display = 'block';
        if (this.value || this.$refs.item.value) {
          this.showInput = true;
        } else {
          this.showInput = false;
        }
      },
    },
    created() {
      axios
        .get(this.$store.state.pageData.EndpointCountries)
        .then((response) => (this.countryList = response.data));
      let self = this;
      this.$validator.extend('countrycode', {
        validate(value) {
          if (typeof value === 'undefined' || value === '') {
            return false;
          }
          const found = self.countryList.some(
            (el) => el.code.toUpperCase() === value.toUpperCase()
          );
          return found;
        },
      });
      if (this.value) {
        this.showInput = true;
      } else {
        this.showInput = false;
      }
    },
    mounted() {
      this.$emit('input', this.value);
    },
  };
</script>
